import React from 'react';
import { PRIORITY_CONFIG, CATEGORY_CONFIG } from './taskConfigs';
import { Plus, Circle, Copy } from 'lucide-react';

export const TemplatesView = ({ templates, setShowTemplateModal, handleCreateFromTemplate }) => (
  <div data-testid="templates-view">
    <div className="flex items-center justify-between mb-4">
      <h2 className="font-semibold text-gray-700">Task Templates</h2>
      <button onClick={() => setShowTemplateModal(true)} className="flex items-center gap-1.5 px-3 py-1.5 text-white rounded-xl text-sm shadow-[0_4px_10px_rgba(217,119,6,0.30)] hover:shadow-[0_6px_14px_rgba(217,119,6,0.40)] transition-all duration-180 ease-out hover:scale-[1.02] active:scale-95" style={{ background: 'linear-gradient(135deg, #D97706 0%, #EA580C 100%)' }} data-testid="create-template-btn">
        <Plus className="w-4 h-4" /> Custom Template
      </button>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {templates.map(tpl => {
        const cat = CATEGORY_CONFIG[tpl.category] || CATEGORY_CONFIG.custom;
        const pri = PRIORITY_CONFIG[tpl.priority] || PRIORITY_CONFIG.medium;
        return (
          <div key={tpl.id} className="bg-white rounded-2xl border border-gray-200 p-4 hover:shadow-md transition-all" data-testid={`template-card-${tpl.id}`}>
            <div className="flex items-center justify-between mb-2">
              <span className={`text-xs px-2 py-0.5 rounded-full ${pri.bg} ${pri.text} border ${pri.border}`}>{pri.label}</span>
              {tpl.is_builtin && <span className="text-[10px] bg-blue-50 text-blue-600 px-2 py-0.5 rounded-full">Built-in</span>}
            </div>
            <h3 className="font-semibold text-sm text-gray-800 mb-1">{tpl.name}</h3>
            <p className="text-xs text-gray-500 mb-3 line-clamp-2">{tpl.description}</p>
            <div className="flex items-center gap-2 text-[11px] text-gray-400 mb-3">
              <span className={cat.color}>{cat.icon} {cat.label}</span>
              <span>Due in {tpl.due_offset_hours}h</span>
            </div>
            {tpl.checklist?.length > 0 && (
              <div className="mb-3 border-t pt-2">
                <div className="text-[10px] text-gray-500 mb-1">{tpl.checklist.length} checklist items:</div>
                {tpl.checklist.slice(0, 3).map((c, i) => (
                  <div key={i} className="text-[10px] text-gray-400 flex items-center gap-1">
                    <Circle className="w-2.5 h-2.5" /> {c.text}
                  </div>
                ))}
                {tpl.checklist.length > 3 && <div className="text-[10px] text-gray-300">+{tpl.checklist.length - 3} more</div>}
              </div>
            )}
            <button onClick={() => handleCreateFromTemplate(tpl)} className="w-full py-2 bg-amber-50 text-amber-700 rounded-xl text-xs font-medium hover:bg-amber-100 transition-colors flex items-center justify-center gap-1.5" data-testid={`use-template-${tpl.id}`}>
              <Copy className="w-3 h-3" /> Create Task from Template
            </button>
          </div>
        );
      })}
    </div>
  </div>
);
